export const LicenseIds = {
  LM: 'LM',
  MA: 'MA',
  OR: 'OR',
  RM: 'RM',
  WM: 'WM',
}
